import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { BlocklyDbType } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { RouteShareService } from './route-share.service';
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { waitSeconds } from '@reflact/tsutil';

export interface BlocklyStage {
  id: string;
  name: string;
  xml: string;
  updatedAt: string;
}




@Injectable({
  providedIn: 'root'
})
export class BlocklyStorageService {
  public stages: BlocklyDbType[] = [];
  public blocklyCreated: EventEmitter<BlocklyDbType> = new EventEmitter<BlocklyDbType>();
  public blocklyUpdated: EventEmitter<BlocklyDbType> = new EventEmitter<BlocklyDbType>();
  public blocklyDeleted: EventEmitter<BlocklyDbType> = new EventEmitter<BlocklyDbType>();
  public EMPTYBLOCKXML = '<xml xmlns="https://developers.google.com/blockly/xml"></xml>';
  public EMPTYBLOCKXML_FOR_GLOBAL = '<xml xmlns="https://developers.google.com/blockly/xml"><block type="MY_START_BLOCK" x="50" y="50"></block></xml>';



  constructor(
    public http: HttpClient,
    public socket: SocketAdminService,
    public rss: RouteShareService,
    public toastr: ToastrService
  ) {
    void this.initSocket();
  }

  public async initSocket() {
    const io = await this.socket.getIo();
    /* io.on('blocklyCreated', ((d) => {
       this._createStageInList(d);
       this.blocklyCreated.emit(d);
     }));
     io.on('blocklyUpdate', ((d) => {
       this._updateStageInList(d);
       this.;.emit(d);
     }));
     io.on('blocklyDelete', ((d) => {
       this._removeStageFromList(d);
       this.blocklyDeleted.emit(d);
     }));
 */


    io.on('blocklyUpdate', (async (d) => {
      console.log("d", d);
      if (d.updatedBy != this.rss.getLoggedInUser()?.name && this.rss.editorItem?.uniqueId == d.uniqueId) {
        //  window.location.reload();
        this.toastr.info('BOT_UPDATED', `${d.updatedBy} hat Änderungen an diesem Logik Editor vorgenommen. Das Fenster aktualisiert sich nun.`, { timeOut: 7000 });
        await waitSeconds(7);
        window.location.reload();
      }
    }));

  }


  public async loadBlocklyStages() {

    this.stages = [];
    const results = await firstValueFrom(this.http.get<BlocklyDbType[]>("/api/admin/blockly/get/" + this.rss.botConfig._id));
    this.stages = results;
    //console.log("LOADED", this.stages);
    return results;
  }

  public async createStage(uniqueId: string, xml: string, name: string = "") {
    const result = await firstValueFrom(this.http.post<BlocklyDbType>("/api/admin/blockly/create/" + this.rss.botConfig._id + "/" + uniqueId,
      {
        xml,
        name
      }
    ));
    this.stages.push(result);
    console.log("CREATED", this.stages);
    return result;
  }

  private _createStageInList(stage: BlocklyDbType) {
    if (stage.botId != this.rss.botConfig._id) {
      return;
    }
    this.stages.push(stage);
  }

  private _removeStageFromList(stage: BlocklyDbType) {
    if (stage.botId != this.rss.botConfig._id) {
      return;
    }
    const index = this.stages.findIndex(s => s._id == stage._id);
    if (index < 0) {
      return;
    }
    this.stages.splice(index, 1);
  }

  private _updateStageInList(stage: BlocklyDbType) {
    if (stage.botId != this.rss.botConfig._id) {
      return;
    }
    const index = this.stages.findIndex(s => s.uniqueId == stage.uniqueId);
    if (index < 0) {
      return;
    }
    this.stages[index] = stage;
  }

  public blocklyEditorIsPossible() {
    const ret = [];
    ret.push(this.rss.editorItem?.xml);
    if (this.rss.editorItem) {
      ret.push(this.rss.editorItem.code);
    }
    /*   if (this.rss.editorItem) {
        if (this.rss.editorItem.code.trim() !== "") {
        }
      } */
    return ret;
  }

  public getStage(uniqueId: string) {
    return this.stages.find(s => s.uniqueId == uniqueId);
  }

  public getStageXmlByUniqueId(uniqueId: string): string {
    const stage = this.getStage(uniqueId);
    if (!stage) {
      return this.getEmptyXmlFor(uniqueId);
    }
    return stage.xml;
  }

  public getEmptyXmlFor(uniqueId: string): string {
    if (uniqueId.startsWith('global_js_')) {
      return this.EMPTYBLOCKXML_FOR_GLOBAL;
    }
    return this.EMPTYBLOCKXML;
  }

  public async deleteStage(uniqueId: string) {
    const result = await firstValueFrom(this.http.post<BlocklyDbType | null>("/api/admin/blockly/delete/" + this.rss.botConfig._id + "/" + uniqueId, {
      botId: this.rss.botConfig._id
    }));
    if (result !== null) {
      this._removeStageFromList(result);
    }
  }

  public async updateStage(uniqueId: string, xml: string, name: string) {
    // console.log("NEW XMK SEND", xml);
    if (this.getStage(uniqueId) == null) {
      return await this.createStage(uniqueId, xml, name);
    }
    const result = await firstValueFrom(this.http.post<BlocklyDbType>("/api/admin/blockly/update/" + this.rss.botConfig._id + "/" + uniqueId, {
      xml,
      name
    }));

    setTimeout(() => {
      if (this.rss.editorItem) {
        this.rss.editorItem.isDirty = false;
      }
    }, 1011);

    this._updateStageInList(result);
    return result;
  }
}
